import i18n from 'client/i18n'
import { createContainerStructure } from 'client/utils/createStructureUtils'
import { EntityWithChildIdsMigrationType } from 'common/types/entities/EntityInterface'
import { createOrderBump } from 'src/shared/entities/order-bump/create-order-bump'
import { createRowColumnLayout } from 'src/shared/entities/row/create-row-column-layout'
import { createText } from 'src/shared/entities/text/create-text'
import { insertChild } from 'src/shared/entities/utils/generate-base-entity'

export function createOrderBumpFromLibrary(
  container: EntityWithChildIdsMigrationType,
  locale: string,
  position = 0,
) {
  const { structure, descendantEntity } = createContainerStructure(
    container,
    locale,
    position,
  )
  const fixedT = i18n.getFixedT(locale)
  const title = fixedT('entities.order_bump.default_title')
  const orderBump = createOrderBump(
    descendantEntity.id,
    title,
    descendantEntity.masterBlockId,
  )

  const {
    row,
    column1,
    structure: rowColumnStructure,
  } = createRowColumnLayout({
    parentEntity: orderBump,
    position: 0,
  })

  orderBump.childIds = [row.id]
  row.padding = {
    paddingTop: 0,
    paddingBottom: 0,
    paddingLeft: 0,
    paddingRight: 0,
  }
  row.mobilePadding = {
    paddingTop: 5,
    paddingBottom: 5,
    paddingLeft: 0,
    paddingRight: 0,
  }

  const text = createText(column1.id, column1.masterBlockId)

  return {
    ...structure,
    ...rowColumnStructure,
    [descendantEntity.id]: {
      ...descendantEntity,
      childIds: insertChild(descendantEntity.childIds, orderBump.id, position),
    },
    [orderBump.id]: orderBump,
    [column1.id]: {
      ...column1,
      childIds: [text.id],
    },
    [text.id]: text,
  }
}
